export interface PortabilityDatesInterfaceState {
  list: Array<string>;
}

export const initialPortabilityDatesState: PortabilityDatesInterfaceState = {
  list: []
};
